import { Injectable } from '@angular/core';
import { LOCAL_STORAGE_KEYS, LocalStorageService } from './local-storage.service';
import { AccessToken } from './rest-api/rest-api';
import { UserService } from './user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  public constructor(
    private userService: UserService,
    private localStorageService: LocalStorageService,
  ) { }

  public updateBackendTokens(apiResponse: AccessToken): void {
    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.TOKEN_LOCAL_STORAGE_KEY,
      value: apiResponse.refresh_token
    });
    this.updateRefreshExpire(apiResponse.expires_in);
    this.userService.updateBearer(apiResponse.access_token);
  }

  private updateRefreshExpire(newExpire: number): void {
    const expiresInMs = newExpire * 1000;
    const newExpireDate = new Date(Date.now() + expiresInMs);
    this.localStorageService.setItem({
      key: LOCAL_STORAGE_KEYS.TOKEN_EXPIRES_LOCAL_STORAGE_KEY,
      value: newExpireDate.toISOString()
    });
  }

}
